import React from 'react';

import styles from '../../../static/scss/components/landing/imageOverlay.module.scss';

type Props = {
  largeImageSrc: string,
  largeImageAlt: string,
  smallImageSrc: string,
  smallImageAlt: string
};

const ImageOverlap = ({
  largeImageSrc,
  largeImageAlt,
  smallImageSrc,
  smallImageAlt
}: Props) => (
  <div className={styles.outer}>
    <div className={styles.inner}>
      <div className={`${styles.image} ${styles.largeImage}`}>
        <img
          src={largeImageSrc}
          alt={largeImageAlt}
          width={382}
          height={382}
          loading="lazy"
        />
      </div>
      <div className={`${styles.image} ${styles.smallImage}`}>
        <img
          src={smallImageSrc}
          alt={smallImageAlt}
          width={174}
          height={174}
          loading="lazy"
        />
      </div>
    </div>
  </div>
);

export default ImageOverlap;
